import React from 'react';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import { PreviewRenderer } from './PreviewRenderer';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const Preview = ({
    open = false,
    onClose = () => { },
    values = {},
    title = 'Preview',
}) => {
    return (
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        {title}
                    </Typography>
                    <IconButton edge="start" color="inherit" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <Box
                sx={{
                    flexGrow: 1,
                    minHeight: 'calc(100vh - 64px)',
                    overflow: 'auto',
                    px: { xs: 1.5, md: 3 },
                    py: { xs: 1.5, md: 3 },
                    background: 'linear-gradient(180deg, #f3efe4 0%, #f8f8f4 100%)',
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: 1440,
                        mx: 'auto',
                        borderRadius: 4,
                        border: '1px solid rgba(27, 31, 35, 0.08)',
                        backgroundColor: 'rgba(255,255,255,0.88)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 24px 70px rgba(23, 25, 28, 0.14)',
                        overflow: 'hidden',
                    }}
                >
                    <PreviewRenderer json={values} />
                </Box>
            </Box>
        </Dialog>
    );
};
